import { render } from "./Denied.vue?vue&type=template&id=125ab4d2&scoped=true"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"

import "./Denied.vue?vue&type=style&index=0&id=125ab4d2&scoped=true&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125ab4d2"]])

export default __exports__